function contextId(id) {
  return `context_of_${id}`
}
export class MicroflowContextProvider {
  
  saveContext(id, context) {
    localStorage.setItem(contextId(id), JSON.stringify(context))
  }
  getContext(id) {
    let currentContext = localStorage.getItem(contextId(id))
    currentContext = JSON.parse(currentContext)
    return currentContext
  }
  clearContext(id) {
    localStorage.removeItem(contextId(id))
  }

}